"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormBalcaoVirtual = void 0;
var React = require("react");
var Icons_1 = require("office-ui-fabric-react/lib/Icons");
var microsoftTeams = require("@microsoft/teams-js");
var react_northstar_1 = require("@fluentui/react-northstar");
var react_icons_northstar_1 = require("@fluentui/react-icons-northstar");
var serventias_api_1 = require("../../api/serventias-api");
var config_api_1 = require("../../api/config-api");
require("./../form-balcao-virtual/form-balcao-virtual.scss");
var data_1 = require("../../constants/data");
var loaderFormBalcaoVirtual_1 = require("../loaders/loaderFormBalcaoVirtual");
var common_helper_1 = require("../../helpers/common-helper");
var FormBalcaoVirtual = /** @class */ (function (_super) {
    __extends(FormBalcaoVirtual, _super);
    function FormBalcaoVirtual(props) {
        var _this = _super.call(this, props) || this;
        _this.serventiaId = null;
        _this.getItem = function (serventiaId) { return __awaiter(_this, void 0, void 0, function () {
            var response, serventiaDetail, diasAtendimento_1, diasAtendimentoStr, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, serventias_api_1.getServentia(serventiaId)];
                    case 1:
                        response = _a.sent();
                        serventiaDetail = response.data;
                        diasAtendimento_1 = [];
                        if (serventiaDetail.horarioAtendimentoDias) {
                            if (serventiaDetail.horarioAtendimentoDias.length > 0) {
                                diasAtendimentoStr = serventiaDetail.horarioAtendimentoDias.split(',');
                                diasAtendimentoStr.forEach(function (item) {
                                    data_1.default.daysOfWeek.filter(function (day) {
                                        if (item.trim() == day.key) {
                                            diasAtendimento_1.push(day);
                                        }
                                    });
                                });
                            }
                        }
                        if (serventiaDetail) {
                            console.log(serventiaDetail);
                            this.setState({
                                ancora: serventiaDetail.Ancora,
                                rowKey: serventiaDetail.rowKey,
                                partitionKey: serventiaDetail.partitionKey,
                                title: serventiaDetail.name,
                                descricao: serventiaDetail.descricao,
                                secaoJudiciaria: serventiaDetail.secaoJudiciaria,
                                diasAtendimento: diasAtendimento_1,
                                horarioAtendimentoInicial: serventiaDetail.horarioAtendimentoInicial,
                                horarioAtendimentoFinal: serventiaDetail.horarioAtendimentoFinal,
                                //meetingUrl: serventiaDetail.meetingJoinUrl,
                                bookingsUrl: serventiaDetail.bookingsUrl,
                                active: !serventiaDetail.deleted,
                                listAssuntos: serventiaDetail.assuntos,
                                loader: false,
                            });
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, error_1];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.onTitleChanged = function (event) {
            _this.setState({
                title: event.target.value,
            });
        };
        _this.onDescricaoChanged = function (event) {
            _this.setState({
                descricao: event.target.value,
            });
        };
        _this.onAssuntoChange = function (event) {
            _this.setState({
                assunto: event.target.value,
            });
        };
        _this.addAssunto = function (assunto) {
            var assuntos = _this.state.listAssuntos || [];
            assuntos.push(assunto);
            _this.setState({
                listAssuntos: assuntos,
                assunto: "",
            });
        };
        _this.deleteAssunto = function (assunto, index) {
            var indexAssunto = _this.state.listAssuntos.indexOf(assunto);
            if (indexAssunto > -1) {
                _this.state.listAssuntos.splice(indexAssunto, 1);
            }
            _this.setState({
                listAssuntos: _this.state.listAssuntos
            });
        };
        _this.onTipoCategoriaChanged = function (event, itemsData) {
            _this.setState({
                secaoJudiciaria: itemsData.value,
            });
        };
        //private onMeetingUrlChanged = (event: any) => {
        //    this.setState({
        //        meetingUrl: event.target.value,
        //    });
        //}
        _this.onBookingsUrlChanged = function (event) {
            var isValidBookingsUrl = true;
            if (event.target.value) {
                isValidBookingsUrl = common_helper_1.CommonHelper.validUrl(event.target.value);
            }
            else {
                isValidBookingsUrl = true;
            }
            _this.setState({
                bookingsUrl: event.target.value,
                isValidBookingsUrl: isValidBookingsUrl,
            });
        };
        _this.copyEnderecoPublicoToClipboard = function () {
            var el = document.createElement('input');
            el.style.position = 'fixed';
            el.style.left = '0';
            el.style.top = '0';
            el.style.opacity = '0';
            el.value = window.location.origin + "/meeting/" + _this.state.ancora;
            document.body.appendChild(el);
            el.focus();
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);
        };
        _this.onHorarioInicialChange = function (event, itemData) {
            var isValidHorario = true;
            var isValidHorarioInicial = true;
            if (itemData.value && _this.state.horarioAtendimentoFinal) {
                var horarioInicial = itemData.value.replace(":", "");
                var horarioFinal = _this.state.horarioAtendimentoFinal.replace(":", "");
                if (Number(horarioInicial) >= Number(horarioFinal)) {
                    isValidHorarioInicial = false;
                }
                else {
                    isValidHorarioInicial = true;
                    _this.setState({ isValidHorarioFinal: true });
                }
            }
            else if (itemData.value) {
                isValidHorario = false;
            }
            _this.setState({
                horarioAtendimentoInicial: itemData.value,
                isValidHorarioInicial: isValidHorarioInicial,
                isValidHorario: isValidHorario
            });
        };
        _this.onHorarioFinalChange = function (event, itemData) {
            var isValidHorario = true;
            var isValidHorarioFinal = true;
            if (itemData.value && _this.state.horarioAtendimentoInicial) {
                var horarioFinal = itemData.value.replace(":", "");
                var horarioInicial = _this.state.horarioAtendimentoInicial.replace(":", "");
                if (Number(horarioInicial) >= Number(horarioFinal)) {
                    isValidHorarioFinal = false;
                }
                else {
                    isValidHorarioFinal = true;
                    _this.setState({ isValidHorarioInicial: true });
                }
            }
            else if (itemData.value) {
                isValidHorario = false;
            }
            _this.setState({
                horarioAtendimentoFinal: itemData.value,
                isValidHorarioFinal: isValidHorarioFinal,
                isValidHorario: isValidHorario
            });
        };
        _this.onDiasAtendimentoChange = function (event, itemsData) {
            _this.setState({
                diasAtendimento: itemsData.value
            });
        };
        _this.isSaveBtnDisabled = function () {
            var title = _this.state.title;
            //const secaoJudiciaria = this.state.secaoJudiciaria;
            //const meetingUrl = this.state.meetingUrl;
            return !(title && _this.state.isValidBookingsUrl && _this.state.isValidHorarioInicial && _this.state.isValidHorarioFinal && _this.state.isValidHorario);
        };
        _this.onSave = function () {
            var _a;
            var diasAtendimento = "";
            (_a = _this.state.diasAtendimento) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
                if (diasAtendimento) {
                    diasAtendimento += ", " + item.key;
                }
                else {
                    diasAtendimento = item.key;
                }
            });
            var serventia = {
                ancora: _this.state.ancora,
                rowKey: _this.state.rowKey,
                partitionKey: _this.state.partitionKey,
                name: _this.state.title,
                descricao: _this.state.descricao,
                secaoJudiciaria: _this.state.secaoJudiciaria,
                //meetingJoinUrl: this.state.meetingUrl,
                bookingsUrl: _this.state.bookingsUrl,
                deleted: !_this.state.active,
                horarioAtendimentoInicial: _this.state.horarioAtendimentoInicial,
                horarioAtendimentoFinal: _this.state.horarioAtendimentoFinal,
                horarioAtendimentoDias: diasAtendimento,
                assuntos: _this.state.listAssuntos
            };
            _this.postServentia(serventia).then(function (response) {
                if (response.data == "Unidade existente") {
                    _this.setState({
                        isValidAncora: false
                    });
                }
                else {
                    microsoftTeams.tasks.submitTask();
                }
            });
        };
        _this.postServentia = function (serventia) { return __awaiter(_this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, serventias_api_1.createOrUpdateServentia(serventia)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_2 = _a.sent();
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.toggleDeleteItem = function (event, data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log(data.checked);
                this.setState({
                    active: data.checked,
                });
                return [2 /*return*/];
            });
        }); };
        Icons_1.initializeIcons();
        _this.state = {
            ancora: "",
            rowKey: "",
            partitionKey: "",
            title: "",
            descricao: "",
            assunto: "",
            listAssuntos: [],
            secaoJudiciaria: "",
            //meetingUrl: "",
            bookingsUrl: "",
            active: true,
            horarioAtendimentoInicial: "",
            horarioAtendimentoFinal: "",
            diasAtendimento: [],
            itemsTiposCategorias: [],
            loader: true,
            isEdit: false,
            isValidBookingsUrl: true,
            isValidHorarioInicial: true,
            isValidHorarioFinal: true,
            isValidHorario: true,
            isValidAncora: true,
        };
        return _this;
    }
    FormBalcaoVirtual.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, serventiaId;
            return __generator(this, function (_a) {
                microsoftTeams.initialize();
                this.getTiposCategorias();
                params = this.props.match.params;
                if ('id' in params) {
                    serventiaId = params['id'];
                    this.getItem(serventiaId);
                    this.setState({
                        isEdit: true
                    });
                }
                else {
                    this.setState({
                        loader: false,
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    FormBalcaoVirtual.prototype.renderAssuntos = function (item, index) {
        var _this = this;
        return {
            key: index,
            className: 'item-assunto',
            header: item,
            truncateHeader: true,
            endMedia: (React.createElement(react_icons_northstar_1.CloseIcon, { circular: true, size: "small", styles: { cursor: 'pointer' }, onClick: function () { return _this.deleteAssunto(item, index); } }))
        };
    };
    FormBalcaoVirtual.prototype.onCancel = function () {
        microsoftTeams.tasks.submitTask();
    };
    FormBalcaoVirtual.prototype.getTiposCategorias = function () {
        var _this = this;
        config_api_1.getAppSettingsTipoCategoria().then(function (settingsData) {
            _this.setState({
                itemsTiposCategorias: settingsData.data ? settingsData.data.tiposCategorias : []
            });
        });
    };
    FormBalcaoVirtual.prototype.render = function () {
        var _this = this;
        if (this.state.loader) {
            return (React.createElement(loaderFormBalcaoVirtual_1.default, null));
        }
        else {
            return (React.createElement("div", { className: "taskModule" },
                React.createElement("div", { className: "formContainer" },
                    React.createElement("div", { className: "formContentContainer" },
                        React.createElement(react_northstar_1.Flex, null,
                            React.createElement(react_northstar_1.Input, { className: "inputField", fluid: true, value: this.state.title, label: "Nome da Unidade: ", onChange: this.onTitleChanged, error: this.state.title != '' && !this.state.isValidAncora, errorIndicator: React.createElement(react_northstar_1.Tooltip, { content: "Já existe uma unidade cadastrada com esse nome" },
                                    React.createElement(react_icons_northstar_1.ExclamationCircleIcon, null)), required: true }),
                            React.createElement("div", { className: "inputField", style: { padding: "0 3.2rem 0 0" } },
                                React.createElement(react_northstar_1.Text, { className: "label-field", content: "Ativo: " }),
                                React.createElement(react_northstar_1.Checkbox, { styles: { paddingLeft: "0px" }, checked: this.state.active, onChange: this.toggleDeleteItem, toggle: true }))),
                        React.createElement("div", { className: "inputField" },
                            React.createElement(react_northstar_1.Text, { className: "label-field", content: "Descri\u00E7\u00E3o: " }),
                            React.createElement(react_northstar_1.TextArea, { variables: {
                                    height: "60px"
                                }, fluid: true, value: this.state.descricao, onChange: this.onDescricaoChanged, required: true, maxLength: 1024 })),
                        React.createElement("div", { className: "inputField" },
                            React.createElement(react_northstar_1.Text, { className: "label-field", content: "Tipo/Categoria: " }),
                            React.createElement(react_northstar_1.Dropdown, { items: this.state.itemsTiposCategorias, fluid: true, clearable: true, checkable: true, placeholder: "Selecione o Tipo/Categoria", onChange: this.onTipoCategoriaChanged, value: this.state.secaoJudiciaria })),
                        React.createElement(react_northstar_1.Input, { className: "inputField", fluid: true, value: this.state.bookingsUrl, label: "Bookings Url: ", onChange: this.onBookingsUrlChanged, error: this.state.bookingsUrl != '' && !this.state.isValidBookingsUrl, errorIndicator: React.createElement(react_northstar_1.Tooltip, { content: "URL inválida" },
                                React.createElement(react_icons_northstar_1.ExclamationCircleIcon, null)) }),
                        React.createElement("div", { className: "inputField" },
                            React.createElement(react_northstar_1.Text, { className: "label-field", content: "Dias de atendimento: " }),
                            React.createElement(react_northstar_1.Dropdown, { multiple: true, fluid: true, clearable: true, checkable: true, items: data_1.default.daysOfWeek, placeholder: "Selecione os dias de atendimento", onChange: this.onDiasAtendimentoChange, value: this.state.diasAtendimento })),
                        React.createElement(react_northstar_1.Flex, { space: "between" },
                            React.createElement(react_northstar_1.FlexItem, { size: "size.half" },
                                React.createElement("div", { className: "inputField" },
                                    React.createElement(react_northstar_1.Text, { className: "label-field", content: "Hor\u00E1rios de atendimento: " }),
                                    React.createElement(react_northstar_1.Dropdown, { items: data_1.default.hoursStart, fluid: true, clearable: true, checkable: true, placeholder: "Selecione o hor\u00E1rio inicial", onChange: this.onHorarioInicialChange, value: this.state.horarioAtendimentoInicial, error: this.state.horarioAtendimentoInicial != '' && !this.state.isValidHorarioInicial }))),
                            React.createElement(react_northstar_1.FlexItem, { size: "size.half" },
                                React.createElement("div", { className: "inputField" },
                                    React.createElement(react_northstar_1.Text, { className: "label-field", styles: { height: "18px" } }),
                                    React.createElement(react_northstar_1.Dropdown, { items: data_1.default.hoursEnd, fluid: true, clearable: true, checkable: true, placeholder: "Selecione o hor\u00E1rio final", onChange: this.onHorarioFinalChange, value: this.state.horarioAtendimentoFinal, error: this.state.horarioAtendimentoFinal != '' && !this.state.isValidHorarioFinal })))),
                        React.createElement(react_northstar_1.Input, { hidden: !this.state.isEdit, icon: React.createElement(react_icons_northstar_1.WindowRestoreIcon, { onClick: this.copyEnderecoPublicoToClipboard, styles: { cursor: 'pointer' } }), className: "inputField endereco-publico", fluid: true, value: window.location.origin + "/meeting/" + this.state.ancora, label: "Endere\u00E7o p\u00FAblico: ", readOnly: true, disabled: true }),
                        React.createElement("div", { className: "inputField" },
                            React.createElement(react_northstar_1.Text, { className: "label-field", content: "Assuntos: " }),
                            React.createElement(react_northstar_1.Input, { icon: this.state.assunto ? React.createElement(react_icons_northstar_1.AddIcon, { styles: { cursor: "pointer" }, onClick: function () { return _this.addAssunto(_this.state.assunto); } }) : React.createElement(React.Fragment, null), fluid: true, value: this.state.assunto, onChange: this.onAssuntoChange })),
                        React.createElement("div", { className: "inputField" },
                            React.createElement(react_northstar_1.List, { items: this.state.listAssuntos ? this.state.listAssuntos.map(this.renderAssuntos.bind(this)) : [] })))),
                React.createElement("div", { className: "footerContainer" },
                    React.createElement("div", { className: "buttonContainer" },
                        React.createElement(react_northstar_1.Button, { content: "Cancelar", id: "cancelBtn", onClick: this.onCancel }),
                        React.createElement(react_northstar_1.Button, { content: "Salvar", id: "saveBtn", onClick: this.onSave, primary: true, disabled: this.isSaveBtnDisabled() })))));
        }
    };
    FormBalcaoVirtual.prototype.escFunction = function (event) {
        if (event.keyCode === 27 || (event.key === "Escape")) {
            microsoftTeams.tasks.submitTask();
        }
    };
    return FormBalcaoVirtual;
}(React.Component));
exports.FormBalcaoVirtual = FormBalcaoVirtual;
//# sourceMappingURL=form-balcao-virtual.js.map